@if (cardInfo) {
  <div class="damage-estimation-card">
    <div class="damage-estimation-card__title">{{ cardInfo.title }}</div>
    <div class="damage-estimation-card__damage">
      <div class="damage-estimation-card__info">
        <div class="damage-estimation-card__labels">
          @for (field of cardInfo.fields; track $index) {
            <div class="damage-estimation-card__item-label">{{ field.label }}</div>
          }
        </div>
        <div class="damage-estimation-card__values">
          @for (field of cardInfo.fields; track $index) {
            <div class="damage-estimation-card__item-value">
              @if (field.value) {
                @if (field.dataType === 'number') {
                  {{ field.value | number: '1.2-2' }}
                } @else {
                  {{ field.value }}
                }
                @if (field.unit) {
                  <span class="damage-estimation-card__item-value-unit">{{ field.unit }}</span>
                }
                @if (field.severity) {
                  <div class="damage-estimation-card__item-value-severity">
                    <bdeo-icon size="extrasmall" [name]="field.severity.iconName"></bdeo-icon>
                    <span [ngStyle]="{ color: field.severity.iconColor }">{{ field.severity.label }}</span>
                  </div>
                }
              } @else {
                <span class="damage-estimation-card__item-value-unit">-</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="damage-estimation-card__actions">
        @if (cardInfo.editable) {
          <bdeo-button
            data-test-id="edit-button"
            size="medium"
            skin="outline"
            type="secondary"
            icon="action-pen-outline"
            bigIcon="true"
            htmlType="button"
            (click)="onEditButtonClick.emit(cardInfo.uuid)"
          ></bdeo-button>
        }
        @if (cardInfo.uuid && cardInfo.hasActions) {
          <bdeo-button
            data-test-id="actions-button"
            size="medium"
            skin="outline"
            type="secondary"
            icon="action-more"
            bigIcon="true"
            htmlType="button"
            (click)="onActionsButtonClick.emit(cardInfo.uuid)"
          ></bdeo-button>
        }
      </div>
    </div>
  </div>
}
